import CompassControl from './CompassControl';

export default CompassControl;
